import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
import { formatDateStr } from '@gp/utils/common';
import { FIELDS, FIELD_NAMES } from '@gp/utils/metricTips';
import moment from 'moment';
import React from 'react';

import type { IRecord } from '@gp/types/global';

const DOC_URL = 'https://drive.weixin.qq.com/s?k=AJEAIQdfAAojst0bEpAGgALgaWAEw';

/**
 * 获取当前日期的下一个季度
 * @returns 当前日期的下一个季度
 */
const getNextQuater = (): moment.Moment => moment().add(1, 'quarters');

export const getKeyMetricsTitleTips = (updateTime?: string) => {
  const nextUpdateTimeM = getNextQuater();
  const updateTimeFormatted = formatDateStr(updateTime);
  const nextUpdateTimeFormatted = !nextUpdateTimeM?.isValid()
    ? ''
    : `${nextUpdateTimeM.format('YYYY')} Q${nextUpdateTimeM.format('Q')}`;

  return (
    <>
      <p>Update Time: {updateTimeFormatted || '-'}</p>
      <p>Next Data Update Time: {nextUpdateTimeFormatted || '-'}</p>
      <div style={{ opacity: 0.6 }}>
        <p>
          Data on this page is managed by the IEGG Finance Team, with the budget updated annually.
        </p>
        <p>
          Quarterly updates for spending and headcount occur in January, April, July, and October,
          aligning with financial data from the previous October, January, April and July.
        </p>
        <p>Forecasts are revised during Gate Reviews.</p>
      </div>
      <p>For FBI Forecast Methodology, click</p>
      <a style={{ marginLeft: 4 }} href={DOC_URL} target="_blank" rel="noreferrer">
        {DOC_URL}
      </a>
    </>
  );
};

const getCommonMetricTips = (title: string, data: Record<string, any>) => (
  <MultipleLinesTextBubble fields={FIELDS} names={FIELD_NAMES} data={data}>
    <div className="dbg-finance-card-title">{title || '-'}</div>
  </MultipleLinesTextBubble>
);

const SALES_METRIC_DEFINITION_MAPPING: IRecord<string> = {
  'Y1 Revenue Forecast ($)': 'Gross revenue forecast for the first 12 months post launch.',
  'Y1 Copy Sales Forecast': 'Number of copies sold forecast for the first 12 months post launch.',
  'Y3 Revenue Forecast ($)': 'Gross revenue forecast for 36 months post launch.',
  'Y3 Copy Sales Forecast': 'Number of copies sold forecast for 36 months post launch.',
};

const getSalesMetricTips = (title: string, updateTime?: string) => {
  const data = {
    definition: SALES_METRIC_DEFINITION_MAPPING[title] || '',
    source: 'P-team, Forecast Business Intelligence, Leadership, Calculate',
    updateCadence: 'Ad hoc, after Gate Reviews',
    dataTime: updateTime || '-',
  };
  return (
    <MultipleLinesTextBubble fields={FIELDS} names={FIELD_NAMES} data={data}>
      <div className="dbg-finance-card-title">{title || '-'}</div>
    </MultipleLinesTextBubble>
  );
};

export const getMetriCardTitleTips = (title: string, updateTime?: string) => {
  switch (title) {
    case 'Spend to Date ($)': {
      const data = {
        definition:
          'Dev Budget Spend to Date: Research & Development Staff Cost + Outsourcing + Other Research & Development Expenses - Video Games Tax Relief (if any)',
        source: 'Project Profit and Loss',
        updateCadence: 'Quarterly',
        dataTime: updateTime || '-',
      };
      return getCommonMetricTips(title, data);
    }
    case 'Current Headcount': {
      const data = {
        definition:
          'including R&D HC, Non R&D HC (i.e. Sales and marketing, Management, Functional support, Customer service)',
        source: 'Project P&L',
        updateCadence: 'Quarterly',
        dataTime: updateTime || '-',
      };
      return getCommonMetricTips(title, data);
    }
    case 'Net Profit Ratio': {
      const data = {
        definition: 'Net Profit / Gross Revenue = (Gross Revenue - Project Cost) / Gross Revenue',
        source: 'P-team, FBI, leadership, calculate',
        updateCadence: 'ad hoc',
        dataTime: updateTime || '-',
      };
      return getCommonMetricTips(title, data);
    }
    case 'Y1 Revenue Forecast ($)':
    case 'Y1 Copy Sales Forecast':
    case 'Y3 Revenue Forecast ($)':
    case 'Y3 Copy Sales Forecast': {
      return getSalesMetricTips(title, updateTime);
    }
  }
};
